import { render } from "./add_eye_procedures_modal.vue?vue&type=template&id=9f9cd0c8&scoped=true"
import script from "./add_eye_procedures_modal.vue?vue&type=script&lang=js"
export * from "./add_eye_procedures_modal.vue?vue&type=script&lang=js"

import "./add_eye_procedures_modal.vue?vue&type=style&index=0&id=9f9cd0c8&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9cd0c8"]])

export default __exports__